export default "__VITE_ASSET__BosAeHg8__"